import React from 'react'
import numeral from 'numeral'
import NProgress from 'react-nprogress'
import axios from 'axios'
import update from 'immutability-helper'

import FilterSidebar from './Components/FilterSidebar'
import Search from './Components/Search'
import Table from './Components/Table'
import EmptyTable from './Components/EmptyTable'
import Tooltip from '../../../Shared/Tooltip'
import Icon from '../../../Shared/Icon/Icon'

class Conversations extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      conversations: {
        data: [],
        meta: {
          totalCount: 0,
          statistics: {
            responseRate: null,
            responseTime: null,
          },
          aggregates: {
            type: {
              all: 0,
              ModelFeedback: 0,
              FileConversionRequest: 0,
              JobApplication: 0,
              personal: 0,
              modelSupport: 0,
              offer: 0,
              cgtraderSupport: 0,
            },
            status: {
              active: 0,
              unread: 0,
              unanswered: 0,
              archived: 0,
            },
          },
        },
      },
    }

    this.onFetchConversationsSuccess = this.onFetchConversationsSuccess.bind(this)
    this.onFetchConversationsFailure = this.onFetchConversationsFailure.bind(this)
    this.moveCheckedToArchive = this.moveCheckedToArchive.bind(this)
    this.moveToArchive = this.moveToArchive.bind(this)
    this.onMoveToArchiveSuccess = this.onMoveToArchiveSuccess.bind(this)
    this.onMoveToArchiveFailure = this.onMoveToArchiveFailure.bind(this)
    this.unarchive = this.unarchive.bind(this)
    this.onUnarchiveSuccess = this.onUnarchiveSuccess.bind(this)
    this.onUnarchiveFailure = this.onUnarchiveFailure.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.selectAll = this.selectAll.bind(this)
    this.onSearchSubmit = this.onSearchSubmit.bind(this)
    this.onSortChange = this.onSortChange.bind(this)
    this.onPaginate = this.onPaginate.bind(this)
    this.onTypeChange = this.onTypeChange.bind(this)
    this.onStatusChange = this.onStatusChange.bind(this)
    this.onUsernameChange = this.onUsernameChange.bind(this)
    this.clearFilters = this.clearFilters.bind(this)
  }

  componentDidMount() {
    this.cancelSource = axios.CancelToken.source()

    this.fetchConversations()
  }

  componentWillUnmount() {
    this.cancelSource.cancel()
  }

  fetchConversations(clearFilters = false) {
    const filters = clearFilters ? null : this.activeFilters()

    NProgress.start()

    axios.get('/api/internal/conversations', { cancelToken: this.cancelSource.token, params: filters })
      .then(this.onFetchConversationsSuccess)
      .catch(this.onFetchConversationsFailure)
  }

  activeFilters() {
    return ({
      page: this.state.conversations.meta.page,
      status: this.state.conversations.meta.status,
      username: this.state.conversations.meta.username,
      type: this.state.conversations.meta.type,
      conversation_ids: this.state.conversations.meta.conversation_ids,
      sort_dir: this.state.conversations.meta.sortDir,
      sort_by: this.state.conversations.meta.sortBy,
      query: this.state.conversations.meta.query,
    })
  }

  onFetchConversationsSuccess(response) {
    NProgress.done()

    this.setState({
      didFetchData: true,
      conversations: response.data,
    })
  }

  onFetchConversationsFailure(xhr, status, err) {
    NProgress.done()
  }

  moveCheckedToArchive() {
    const conversationIds = this.state.conversations.data.filter(
      (c) => c.attributes.checked === true
    ).map((c) => parseInt(c.relationships.conversation.data.id))

    if (conversationIds.length > 0) {
      NProgress.start()

      axios.post('/api/internal/conversations/archive', { conversation_ids: conversationIds })
        .then(this.onMoveToArchiveSuccess)
        .catch(this.onMoveToArchiveFailure)
    } else {
      App.events.publish('app:notification:flash:error', 'You have not selected any conversations')
    }
  }

  moveToArchive(e) {
    NProgress.start()

    axios.post('/api/internal/conversations/archive', { conversation_ids: e.currentTarget.getAttribute('value') })
      .then(this.onMoveToArchiveSuccess)
      .catch(this.onMoveToArchiveFailure)
  }

  onMoveToArchiveSuccess(response) {
    this.fetchConversations()

    // Tech debt
    App.events.publish('app:notification:flash:success', 'Selected messages were successfully moved to archive')
  }

  onMoveToArchiveFailure(xhr, status, err) {
    NProgress.done()

    // Tech debt
    App.events.publish('app:notification:flash:error', 'Unfortunately messages couldn\'t be moved to archive')
  }

  unarchive(e) {
    NProgress.start()

    axios.post('/api/internal/conversations/unarchive', { conversation_ids: e.currentTarget.getAttribute('value') })
      .then(this.onUnarchiveSuccess)
      .catch(this.onUnarchiveFailure)
  }

  onUnarchiveSuccess(response) {
    this.fetchConversations()

    // Tech debt
    App.events.publish('app:notification:flash:success', 'Message were successfully unarchived')
  }

  onUnarchiveFailure(xhr, status, err) {
    NProgress.done()

    // Tech debt
    App.events.publish('app:notification:flash:error', 'Unfortunately message couldn\'t be unarchived')
  }

  selectAll(e) {
    const check = !!e.target.checked

    this.setState({
      checked: this.state.conversations.data.map((e) => { return (e.attributes.checked = check) }),
    })
  }

  handleChange(e) {
    this.setState({
      conversations: update(this.state.conversations, { data: { [e.target.getAttribute('data-index')]: { attributes: { checked: { $set: e.target.checked } } } } }),
    })
  }

  onSearchSubmit(text) {
    this.state.conversations.meta.query = text
    this.resetPagination()

    return this.fetchConversations()
  }

  onPaginate(pageNumber) {
    this.state.conversations.meta.page = pageNumber

    return this.fetchConversations()
  }

  onSortChange(attribute, direction) {
    this.state.conversations.meta.sortBy = attribute
    this.state.conversations.meta.sortDir = direction

    return this.fetchConversations()
  }

  onTypeChange(e) {
    this.state.conversations.meta.type = e.currentTarget.getAttribute('value')
    this.resetPagination()

    return this.fetchConversations()
  }

  onStatusChange(e) {
    this.state.conversations.meta.status = e.currentTarget.getAttribute('value')
    this.resetPagination()

    return this.fetchConversations()
  }

  onUsernameChange(e) {
    const searchableUsername = e.currentTarget.getAttribute('value')

    if (this.state.conversations.meta.username == searchableUsername) {
      this.state.conversations.meta.username = ''
    } else {
      this.state.conversations.meta.username = searchableUsername
    }
    this.resetPagination()

    return this.fetchConversations()
  }

  clearFilters() {
    return this.fetchConversations(true)
  }

  resetPagination() {
    this.state.conversations.meta.page = 1
  }

  tableComponent() {
    if (this.state.didFetchData) {
      return this.state.conversations.meta.totalCount > 0
        ? (
          <Table
            conversations={this.state.conversations}
            handleChange={this.handleChange}
            selectAll={this.selectAll}
            moveCheckedToArchive={this.moveCheckedToArchive}
            moveToArchive={this.moveToArchive}
            unarchive={this.unarchive}
            onSortChange={this.onSortChange}
            onPaginate={this.onPaginate}
            clearFilters={this.clearFilters}
            hideMoveToArchiveButton={this.state.conversations.meta.status === 'archived'}
          />
        )
        : <EmptyTable clearFilters={this.clearFilters} />
    }
    return null
  }

  render() {
    return (
      <div className="row">
        <div className="col-12">
          {!this.props.newRoyaltyUi && (
            <ul className="breadcrumb">
              <li className="breadcrumb__item">
                <a href="/">CGTrader</a>
              </li>
              <li className="breadcrumb__item">
                <a href="/profile/dashboard">Profile</a>
              </li>
              <li className="breadcrumb__item is-active">My Conversations</li>
            </ul>
          )}
          <div className={`profile-conversations-statistics${this.props.newRoyaltyUi ? ' mt-40' : ''}`}>
            <div className="u-float-right">
              <span>
                <Icon type="reply" />
                Response rate:
                <b className="u-ml10 u-mr10">
                  {numeral(this.state.conversations.meta.statistics.responseRate).format('0%')}
                </b>
                <Tooltip
                  tooltipClassName="u-text-center clickable"
                  content={(
                    <>
                      Your response rate measures how consistently you respond to your conversations.
                      For more info please check this
                      <a href="https://help.cgtrader.com/hc/en-us/articles/360015144957-How-is-my-Response-Rate-calculated-" target="_blank"> article.</a>
                    </>
                  )}
                  delayHide={1000}
                  clickable
                  id="response-rate"
                >
                  <Icon type="question-circle" color="primary" />
                </Tooltip>
              </span>
              <span>
                <Icon type={['far', 'clock']} className="u-ml10" />
                Response time:
                <b className="u-ml10 u-mr10">
                  {numeral(this.state.conversations.meta.statistics.responseTime).format('0.0')}h
                </b>
                <Tooltip
                  tooltipClassName="u-text-center"
                  content="Your response time measures how quickly you respond to your conversations."
                  id="response-time"
                >
                  <Icon type="question-circle" color="primary" />
                </Tooltip>
              </span>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-3">
          <FilterSidebar
            aggregates={this.state.conversations.meta.aggregates}
            onTypeChange={this.onTypeChange}
            selectedType={this.state.conversations.meta.type}
            onUsernameChange={this.onUsernameChange}
            selectedUsername={this.state.conversations.meta.username}
          />
        </div>
        <div className="col-12 col-md-9">
          <Search
            aggregates={this.state.conversations.meta.aggregates.status}
            onFormSubmit={this.onSearchSubmit}
            onStatusChange={this.onStatusChange}
            selectedStatus={this.state.conversations.meta.status}
          />
          <div className="conversations__container">
            {this.tableComponent()}
          </div>
        </div>
      </div>
    )
  }
}

export default Conversations
